/* eslint-disable react/prop-types */
import { LogoWithText, useSurveyTheme } from '@sm/webassets';
import { T, t } from '@sm/intl';
import React, { useMemo, FC } from 'react';
import useStyles from './useStyles';
import checkDarkMode from '~app/helpers/luminance';
import { Theme } from '~app/sharedTypes';

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface FooterPoweredByLogoBlockProps {
  /** A boolean prop for grayscale themes. */
  isGrayScale: boolean;
  /** URL for when you click on the survey monkey logo. */
  surveyMonkeyURL: string;
  /** URL for when you click the how it works anchor element */
  howItWorksURL: string;
}
// TODO: add defineMessages when ready for translations
const DEFAULT_COPY = {
  POWERED_BY: {
    id: 'FooterPoweredByLogoBlock.PoweredBy',
    defaultMessage: 'Powered by',
    description: '[Type: Paragraph][Vis: high] - Powered by text',
  },
  SEE_HOW: {
    id: 'FooterPoweredByLogoBlock.SeeHow',
    defaultMessage: 'See how easy it is to',
    description: '[Type: Paragraph][Vis: high] - See how easy it is to text',
  },
  CREATE_SURVEY: {
    id: 'FooterPoweredByLogoBlock.CreateSurvey',
    defaultMessage: 'create a survey.',
    description: '[Type: Link][Vis: high] - create a survey',
  },
  LOGO: {
    id: 'FooterPoweredByLogoBlock.Logo',
    defaultMessage: 'Survey monkey logo',
    description: '[Type: Link][Vis: low] - Survey monkey logo alt text for link in image',
  },
};

const FooterPoweredByLogoBlock: FC<FooterPoweredByLogoBlockProps> = ({
  isGrayScale,
  surveyMonkeyURL,
  howItWorksURL,
}) => {
  const surveyTheme: Theme = useSurveyTheme();
  const bgColor = surveyTheme.primaryBackgroundColor || '#fff';
  const logoColor = useMemo(() => {
    const isDarkBackground = checkDarkMode(bgColor);
    if (isDarkBackground) {
      return '#FFFFFF';
    }
    return isGrayScale ? 'rgba(0,0,0, 0.5)' : '';
  }, [bgColor, isGrayScale]);

  const { container, text, link, logo, imageLink } = useStyles({ surveyTheme, logoColor });
  return (
    <div className={container}>
      <p className={text}>
        <T desc={DEFAULT_COPY.POWERED_BY} />
      </p>
      <a className={imageLink} href={surveyMonkeyURL} aria-label={t(DEFAULT_COPY.LOGO)}>
        <span role="presentation" aria-hidden="true">
          <LogoWithText className={logo} />
        </span>
      </a>
      <p className={text}>
        <T desc={DEFAULT_COPY.SEE_HOW} />{' '}
        <a className={link} href={howItWorksURL}>
          <T desc={DEFAULT_COPY.CREATE_SURVEY} />
        </a>
      </p>
    </div>
  );
};

export default FooterPoweredByLogoBlock;
